import dataProvider from './dataProvider/'

export { dataProvider }
export default dataProvider
